import { TransitionDto } from "@repo/api/transition";
import React from "react";
import { useCurrentFrame, AbsoluteFill, useVideoConfig } from "remotion";
import { ImageTransitionBuilders } from "./ImageTransitionBuilder.ts";

type Props = {
  children: React.ReactNode;
  entryTransition: TransitionDto | null;
  exitTransition: TransitionDto | null;
  durationInFrames: number;
};

export default function ImageTransitionWrapper({
  children,
  entryTransition,
  exitTransition,
  durationInFrames,
}: Props) {
  const { fps } = useVideoConfig();
  const currentFrame = useCurrentFrame();

  const entryTransitionWrappers = entryTransition
    ? (ImageTransitionBuilders.get(entryTransition.kind)?.wrappers ?? null)
    : null;

  const exitTransitionWrappers = exitTransition
    ? (ImageTransitionBuilders.get(exitTransition.kind)?.wrappers ?? null)
    : null;

  const EntryOverlay =
    entryTransitionWrappers?.nextImageWrapper?.overlayComponent;

  const ExitOverlay =
    exitTransitionWrappers?.prevImageWrapper?.overlayComponent;

  const entryStyle =
    entryTransitionWrappers?.nextImageWrapper?.buildWrapperStyle?.({
      imageTransition: entryTransition!,
      fps,
      imageDurationInFrames: durationInFrames,
      currentFrame,
    }) ?? null;

  const exitStyle =
    exitTransitionWrappers?.prevImageWrapper?.buildWrapperStyle?.({
      imageTransition: exitTransition!,
      fps,
      imageDurationInFrames: durationInFrames,
      currentFrame,
    }) ?? null;

  const style = entryStyle ?? exitStyle ?? {};

  return (
    <AbsoluteFill
      style={{
        ...style,
        overflow: "hidden",
      }}
    >
      {children}
      {EntryOverlay && (
        <EntryOverlay
          imageTransition={entryTransition!}
          fps={fps}
          imageDurationInFrames={durationInFrames}
          currentFrame={currentFrame}
        />
      )}
      {ExitOverlay && (
        <ExitOverlay
          imageTransition={exitTransition!}
          fps={fps}
          imageDurationInFrames={durationInFrames}
          currentFrame={currentFrame}
        />
      )}
    </AbsoluteFill>
  );
}
